var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgDataIcon(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 38,
    height: 35,
    viewBox: "0 0 38 35",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M3.16667 4.00219H34.8333V28.282H3.16667L3.16667 4.00219ZM0 4.00219C0 2.21428 1.41777 0.764893 3.16667 0.764893H34.8333C36.5822 0.764893 38 2.21428 38 4.00219V28.282C38 30.0699 36.5822 31.5193 34.8333 31.5193H22.9583V34.3519H15.8333L15.8333 31.5193H3.16667C1.41776 31.5193 0 30.0699 0 28.282V4.00219ZM8.70833 12.9048L8.70833 25.854H11.875V12.9048H8.70833ZM14.6458 25.854L14.6458 6.02551H17.8125V25.854H14.6458ZM20.5833 9.26281V25.854H23.75L23.75 9.26281H20.5833ZM26.5208 25.854V18.5701H29.6875V25.854H26.5208Z",
    fill: "#F5F6F7"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgDataIcon);
export default __webpack_public_path__ + "static/media/dataIcon.24b7b2e8e62fc22b7e8c772ab48a7d18.svg";
export { ForwardRef as ReactComponent };